var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-return"},[_c('button',{class:['btn', 'btn-' + _vm.color],style:(_vm.buttonStyle),attrs:{"type":"button"}},[_c('div',{staticClass:"d-flex flex-row"},[_c('IconReturn',{attrs:{"width":"15px","height":"15px"}}),_vm._v("   "+_vm._s(_vm.labelName)+" ")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }